import { apiGet, apiPatch, apiPost, apiDelete } from './client.js';

export type EstimateRecord = {
  id: string;
  estimateNumber: string;
  status: string;
  ticketId: string;
  services: Array<{ serviceName: string; price: number; serviceId?: string }>;
  parts: Array<{ partName: string; price: number }>;
  subtotal: string;
  tax: string;
  total: string;
  notes: string | null;
  validUntil: string | null;
  requiresSignature: boolean;
  approvalToken: string | null;
  approvalLink: string | null;
  sentAt: string | null;
  sentVia: string | null;
  approvedAt: string | null;
  approvedByName: string | null;
  declinedAt: string | null;
  declineReason: string | null;
  createdAt: string;
};

export function listEstimates(params?: {
  ticketId?: string;
  status?: string;
  page?: number;
  pageSize?: number;
}) {
  return apiGet<EstimateRecord[], { page: number; pageSize: number; total: number }>(
    '/api/v1/estimates',
    { params },
  );
}

export function createEstimate(body: {
  ticketId: string;
  services: Array<{ serviceName: string; price: number; serviceId?: string }>;
  parts?: Array<{ partName: string; price: number }>;
  notes?: string;
  validDays?: number;
  requiresSignature?: boolean;
  sendVia?: 'email' | 'sms' | 'both' | 'none';
}) {
  return apiPost<EstimateRecord>('/api/v1/estimates', body).then((r) => r.data);
}

export function sendEstimate(id: string, via: 'email' | 'sms' | 'both') {
  return apiPost<EstimateRecord>(`/api/v1/estimates/${id}/send`, { via }).then((r) => r.data);
}

export function createCustomerPortal(
  customerId: string,
  body?: { portalEmail?: string; canCreateTickets?: boolean },
) {
  return apiPost<{
    success: boolean;
    portalEmail: string;
    tempPassword: string;
    tenantSlug: string;
    loginUrl: string;
  }>(`/api/v1/customers/${customerId}/portal/create`, body ?? {}).then((r) => r.data);
}

export function updateCustomerPortalSettings(
  customerId: string,
  body: { canCreateTickets?: boolean; portalEnabled?: boolean },
) {
  return apiPatch(`/api/v1/customers/${customerId}/portal/settings`, body).then((r) => r.data);
}

export function revokeCustomerPortal(customerId: string) {
  return apiDelete(`/api/v1/customers/${customerId}/portal/revoke`);
}

export function sendCustomerPortalReset(customerId: string) {
  return apiPost<{ success: boolean }>(`/api/v1/customers/${customerId}/portal/send-reset`, {}).then(
    (r) => r.data,
  );
}
